export const backToApplication = () => {
    window.RahmetApp.backToRahmetApp();
};
